import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';
import { UiFlowNodeFrameComponent } from '../../atoms/flow-node-frame/flow-node-frame.component';

@Component({
  selector: 'ui-flow-terminator-node',
  standalone: true,
  imports: [UiFlowNodeFrameComponent, UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ui-flow-node-frame shape="pill">
      <ui-flow-label [text]="label()" tone="strong" />
    </ui-flow-node-frame>
  `,
  styles: `
    /* Ancho fijo: debe coincidir con NODE_SIZES.terminator en flow-layout.util.ts */
    :host {
      display: inline-flex;
      width: 100px;
      justify-content: center;
    }
    ui-flow-node-frame {
      --ui-flow-node-frame-pill-min-width: 0px;
      --ui-flow-node-frame-pill-padding-inline: 12px;
      width: 100%;
    }
  `,
})
export class UiFlowTerminatorNodeComponent {
  readonly label = input.required<string>();
}
